













import { PageMode } from '@/main/utils/pageMode';
import { openEdit, openList } from '@/main/router/routerPath';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';

import { NAME } from './constants';
import { store } from '../store/edit';


export default EditStoreMixin.extend({
	name: 'ZapujckyCard',
	data() {
		return {
			NAME,
		};
	},
	computed: {
		...genVuexComputeds(store),
		zapujcka() {
			return NAME;
		},
	},
	methods: {
		onZapujckyClick() {
			openList(NAME, { filter: { ZakazkaId: this.ZakazkaId } });
		},
		createClickFunc() {
			openEdit(
				NAME,
				PageMode.CREATE,
				{ props: true, filter: { ZakazkaId: this.ZakazkaId } },
			);
		},
		editClick(event: any) {
			openEdit(NAME, PageMode.EDIT, { id: event.data.ID });
		},
	},
});
